<template>
  <!-- Proportioned like the real card so the grid does not shift when the
       cards arrive: same 16/9 media, same two-line title box, same meta row. -->
  <div class="gr-skeleton" aria-hidden="true">
    <div class="gr-skeleton__media" />
    <div class="gr-skeleton__body">
      <div class="gr-skeleton__line gr-skeleton__line--title" />
      <div
        class="gr-skeleton__line gr-skeleton__line--title"
        style="width: 70%"
      />
      <div class="gr-skeleton__line" style="width: 40%" />
      <div class="gr-skeleton__meta">
        <div class="gr-skeleton__line" style="width: 38%" />
        <div class="gr-skeleton__line" style="width: 30%" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.gr-skeleton {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid var(--gr-line);
  border-radius: 4px;
  background-color: var(--gr-surface);
}

.gr-skeleton__media {
  aspect-ratio: 16 / 9;
  border-radius: 4px 4px 0 0;
  background-color: var(--gr-green-tint);
}

.gr-skeleton__body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 16px;
}

.gr-skeleton__line {
  height: 14px;
  margin-bottom: 8px;
  border-radius: 2px;
  background-color: rgba(26, 28, 25, 0.08);
}

.gr-skeleton__line--title {
  height: 16px;
}

.gr-skeleton__meta {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
  padding-top: 12px;
}

.gr-skeleton__meta .gr-skeleton__line {
  margin-bottom: 0;
}

/* The pulse is the only motion here and it is purely decorative. */
@media (prefers-reduced-motion: no-preference) {
  .gr-skeleton__media,
  .gr-skeleton__line {
    animation: gr-skeleton-pulse 1.6s ease-in-out infinite;
  }
}

@keyframes gr-skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}
</style>
